import { render } from "./Proposal.vue?vue&type=template&id=0efcdafa&scoped=true"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"

import "./Proposal.vue?vue&type=style&index=0&id=0efcdafa&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efcdafa"]])

export default __exports__